import type { BottomTabNavigationOptions } from '@react-navigation/bottom-tabs';
import { BottomTabBarHeightContext } from '@react-navigation/bottom-tabs';
import { useNavigation as useReactNavigation, useRoute as useReactRoute } from '@react-navigation/native';
import type { NativeStackNavigationOptions } from '@react-navigation/native-stack';
import type { ScreenParameters, SpecificNavigationProp, SpecificRouteProp } from 'app/types/navigation';
import { useContext, useLayoutEffect } from 'react';

export function useNavigationOptions<T extends keyof ScreenParameters>(
  navigation: SpecificNavigationProp<T>,
  options?: BottomTabNavigationOptions & NativeStackNavigationOptions,
  byPass?: boolean,
) {
  useLayoutEffect(() => {
    if (byPass) {
      return;
    }

    if (options) {
      navigation.setOptions(options);
    }
  }, [options, navigation, byPass]);
}

export function useNavigation<T extends keyof ScreenParameters>(
  options?: BottomTabNavigationOptions & NativeStackNavigationOptions,
) {
  const navigation = useReactNavigation<SpecificNavigationProp<T>>();

  useNavigationOptions(navigation, options, undefined);

  return navigation;
}

export function useRoute<T extends keyof ScreenParameters>() {
  return useReactRoute<SpecificRouteProp<T>>();
}

export function useBottomTabBarHeightOrDefault() {
  return useContext(BottomTabBarHeightContext) ?? 0;
}
